import styled from 'styled-components';
import { ifProp, palette } from 'styled-tools';

import {
	Button as DesignSystemButton,
	fontWeight,
	FontWeights,
	maxWidth,
	minWidth,
	QuestionnaireTile,
	Text,
} from '@calm-web/design-system';

export const Wrapper = styled.div`
	margin: 8px 0;
	text-align: center;

	${minWidth('tablet')} {
		margin: 0;
	}
`;

export const Heading = styled(Text).attrs({
	el: 'h1',
	styleAs: 'h4',
})`
	color: ${palette('gray7')};
	${fontWeight(FontWeights.Regular)};
	margin-top: 0;
	margin-bottom: 4px;

	${maxWidth('tablet')} {
		margin-bottom: 8px;
	}
`;

export const Body = styled.p`
	color: ${palette('gray7')};
	margin-bottom: 16px;

	${minWidth('tablet')} {
		margin-bottom: 32px;
	}
`;

export const Answer = styled(QuestionnaireTile)<{
	$isEntering: boolean;
	$transitionDelay: number;
}>`
	opacity: ${ifProp('$isEntering', 0, 1)};
	transition-delay: ${props => props.$transitionDelay}ms;
	transform: ${ifProp('$isEntering', 'translateY(8px)', 'translateY(0)')};
`;

export const Button = styled(DesignSystemButton)`
	margin-bottom: 12px;
	margin-top: 24px;

	${minWidth('tablet')} {
		margin-bottom: 0;
	}
`;

export const SkipButton = styled(Button)`
	${fontWeight(FontWeights.Regular)};
	margin-top: 8px;
	width: 100%;
`;

export const GoalsListWrapper = styled.ul`
	list-style-type: none;
	padding: 0;
`;
